import http from "infra/http";
import { useMutation } from "react-query";

function useAprovarProcuracao({
  idVotacao,
  idProcuracao,
}: {
  idVotacao: string;
  idProcuracao: string;
}) {
  return useMutation(
    `rejeitar/v1/votacao/${idVotacao}/procuracao/${idProcuracao}`,
    async () => {
      const result = await http.post(
        `/v1/votacao/${idVotacao}/procuracao/${idProcuracao}/aprovar`,
      );

      return result;
    },
    { retry: false }
  );
}

export default useAprovarProcuracao;
